import { /* makeStyles, */ /* Theme, */ Typography } from "@material-ui/core";
import React from "react";
import careerImage from "./Assets/career.svg";
import clockImage from "./Assets/clock.svg";
import learningImage from "./Assets/learning.svg";
import navigationImage from "./Assets/navigation.svg";
import payImage from "./Assets/pay.svg";
import videoImage from "./Assets/video.svg";
import Categories from "./Categories";
import CategoryData from "./CategoryData";
import ContactInformation from "./WDContactInformation";
import Title from "../Introduction/Title";

// const useStyles = makeStyles((theme: Theme) => ({}));

const categories = [
  {
    title: "Getting Started for Employee",
    icon: navigationImage,
    subCategories: [
      {
        title: "Video",
        icon: videoImage,
        mainLinks: [
          {
            title: "Getting Started for Employees / Installing Workday mobile",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8716-a456-4de8-aa7c-386720f37071",
          },
          {
            title: "Basic Concept, Navigation and Terminology (Modify Personal Information, Photos etc)",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8711-a456-4aa8-aa7c-386720f37071",
          },
        ],
        jobAids: [
          {
            title: "Employee FAQ's",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/18e7ad38-1c7e-4684-a7d5-09c0351779cd",
          },
          {
            title: "Getting Started for Employees / Installing Workday mobile",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ah56-4de8-aa7c-386720f37071",
          },
          {
            title: "Modify Personal Information",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-an56-4de8-aa7c-386720f37071",
          },
          {
            title: "User Tools and Navigation",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-au56-4de8-aa7c-386720f37071",
          },
          {
            title: "Change Champion Networks by Community",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/11965f20-3a8c-4f1f-a8de-3acbc7034cf3",
          },
          {
            title: "Accessing the Workday Desktop Site",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/76ecfb55-1555-4c90-b7d2-d44d32a88390",
          },
          {
            title: "AskHR",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/e7f00d3f-2f71-41e1-878f-1c7f19cf3b3c",
          },
        ],
      },
    ],
  },
  {
    title: "Payroll",
    icon: payImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "View Pay Slips",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8711-a456-4aa8-cc7c-386720f37071",
          },
          {
            title: "Payment Elections (tax withholdings, direct deposit, etc.)",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8711-a456-4aa8-gg7c-386720f37071",
          },
        ],
        jobAids: [
          {
            title: "View Pay Slips",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ak56-4de8-aa7c-386720f37071",
          },
          {
            title: "Payment Elections (tax withholdings, direct deposit, etc.)",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ak56-4de8-aa7c-386720f37071",
          },
          {
            title: "Understand Your Paycheck Stub",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/97ba46bb-d04b-4101-8ea3-877073d67ef2",
          },
        ],
      },
    ],
  },
  {
    title: "Time Off and Timecards",
    icon: clockImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "Request Time Off",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8730-a456-4de8-aa7c-386720f37071",
          },
        ],
        jobAids: [
          {
            title: "Request Time Off",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-as56-4de8-aa7c-386720f37071",
          },
          {
            title: "Exempt Employee Timecards",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/8fb5c30e-6668-4a2c-a6b5-9c018d8571f8",
          },
          {
            title: "Kronos FAQs",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/ce91ecb0-a769-4c23-92e5-d75594292e6d",
          },
          {
            title: "Nonexempt Employee Timeclock Instructions",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/724f87cd-533a-438b-8fb8-08d85e2d99b7",
          },
        ],
      },
    ],
  },
  {
    title: "Job Changes",
    icon: careerImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [],
        jobAids: [
          {
            title: "Employee Referrals and Job Search",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-af56-4de8-aa7c-386720f37071",
          },
          {
            title: "Complete a Performance Review",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ac56-4de8-aa7c-386720f37071",
          },
          {
            title: "Update Your Talent Profile",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-at56-4de8-aa7c-386720f37071",
          },
        ],
      },
    ],
  },
  {
    title: "Learning",
    icon: learningImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "How to Enroll in a Course, Drop a Course, and Rate a Course",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/0aea8711-a456-4aa8-ii7c-386720f37071",
          },
        ],
        jobAids: [
          {
            title: "How to Enroll in a Course, Drop a Course, and Rate a Course",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/0aea8755-ag46-4de8-aa7c-386720f37071",
          },
          {
            title: "Identify Learning Items Needing Completion",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/8d318f2a-6853-483f-b11e-1e2b76a39a7f",
          },
        ],
      },
    ],
  },
  {
    title: "Workday Wednesday Recorded Sessions",
    icon: navigationImage,
    subCategories: [
      {
        title: "Video",
        icon: videoImage,
        mainLinks: [
          {
            title: "Workday Wednesday: Getting Started",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/21b93446-4b68-49eb-a23a-7f1e22da8935",
          },
          {
            title: "Workday Wednesday: Time off Requests, Payslips and Accruals",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/06bf02cb-305f-4792-8771-a3a27d4824a2",
          },
          {
            title: "Workday Wednesday: Learning",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/a33f4709-8ffe-448d-8d61-3beb7d97c23b",
          },
          {
            title: "Workday Wednesday: You've Got Talent",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/b0ce9d89-7d0c-44da-b4b4-9e9f29b0b132",
          },
        ],
        jobAids: [],
      },
    ],
  },
] as CategoryData[];

export default function EmployeeLinks() {
  //const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h4">Quick Links for Employees</Typography>
      <p>
        Welcome to Workday for Employees! <br />
        With a Go Begin Date of October 5, 2020, we are excited for employees to begin learning about Workday and
        exploring all of the self service options. <br />
        With Workday, you’ll be able to view your own information in your Workday profile and perform many tasks right
        from your mobile device.
        <br />
        Employees will have the ability to:
        <ul>
          <li>View accruals and request time off</li>
          <li>View paycheck and update payment elections</li>
          <li>Update contact information and profile photo</li>
          <li>View company org charts</li>
          <li>Manage performance reviews, talent profile and individual talent items</li>
          <li>Complete assigned courses and self-enroll in Erickson University courses of your choice</li>
          <li>Update career preferences, view and apply for open positions</li>
          <li>And more!</li>
        </ul>
      </p>

      <br />

      <Categories data={categories} />

      <br />
      <ContactInformation />
    </React.Fragment>
  );
}
